import NoteBlock from './NoteBlock';
import NotesList from '../components/NotesList';
import NotesListFilterController from '../components/NotesListFilterController';

const NotesPage = () => {
    return (<>
        <div className="email-app">
            {/* <div className="col email-side-nav remain-height ov-h">
                <div className="row h-100 layers">
                    <NotesListFilterController/>
                    <NotesList/>
                </div>
            </div> */}
            <div className="col email-wrapper remain-height bgc-white ov-h">
                <div className="row">
                    <NotesList/>
                </div>
          </div>
        </div>
    </>);
}

export default NotesPage;